export default __webpack_public_path__ + "static/media/rm5.f3a84e82.png";